
export const SPINNER_SIZES = Object.freeze({
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
})

export default {
  name: 'EoSpinner',
  props: {
    /**
     * Size of the icon: (xs) (sm) (md) (lg) (xl)
     */
    size: {
      type: String,
      validator: prop => Object.values(SPINNER_SIZES).includes(prop),
      default: 'sm',
    },
    /**
     * Right position of the spinner for use beside other inline elements
     */
    right: {
      type: Boolean,
      default: false,
    },
    /**
     * Left position of the spinner for use beside other inline elements
     */
    left: {
      type: Boolean,
      default: false,
    },
    /**
     * Style: color
     */
    color: {
      type: String,
      default: 'primary',
    },
    /**
     * Style: secondary color
     */
    colorSecondary: {
      type: String,
      default: 'secondary',
    },
    /**
     * Style: only show the circle, not the "e"
     */
    compact: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      // Used to scope id's to only this svg instance on the page
      id: null,
      rotationDuration: '900', // milliseconds
      centerY: '108.5',
    }
  },
  computed: {
    classes () {
      return {
        'eo-spinner': true,
        'is-compact': !!this.compact,
        [this.size]: !!this.size,
        'left': !!this.left,
        'right': !!this.right,
      }
    },
    hexColor () {
      return this.$color.getHex(this.color) || 'currentColor'
    },
    hexColorSecondary () {
      return this.$color.getHex(this.colorSecondary) || this.$color.step(this.color, -2)
    },
  },
  mounted () {
    this.id = this._uid
  },
}
